import axios from "axios";
import { ErrorMessage, handleToastSuccess } from "../components";
const baseUrl = "https://elephant.hassy.ml/api";
// const baseUrl = "http://192.168.0.172:3000/api";

const imageUrl = "https://elephant.hassy.ml";

const Post = async (api, data, token) => {
  let accessToken = !token ? await sessionStorage.getItem("access_token") : {};
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrl}/${api}`, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "*/*",
        },
      })
      .then((response) => {
        resolve(response);
        handleToastSuccess(response.data.message, true);
      })
      .catch((error) => {
        reject(error);
        ErrorMessage(error);
      });
  });
};

const Get = async (api, token) => {
  let accessToken = !token ? await sessionStorage.getItem("access_token") : {};
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrl}/${api}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "*/*",
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const Update = async (api, data, token) => {
  let accessToken = !token ? await sessionStorage.getItem("access_token") : {};
  return new Promise((resolve, reject) => {
    axios
      .put(`${baseUrl}/${api}`, data, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "*/*",
        },
      })
      .then((response) => {
        resolve(response);
        handleToastSuccess(response.data.message, true);
      })
      .catch((error) => {
        reject(error);
        ErrorMessage(error);
      });
  });
};

const Delete = async (api, token) => {
  let accessToken = !token ? await sessionStorage.getItem("access_token") : {};
  return new Promise((resolve, reject) => {
    axios({
      method: "delete",
      url: `${baseUrl}/${api}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: "*/*",
      },
    })
      .then((response) => {
        resolve(response);
        handleToastSuccess(response.data.message, true);
      })
      .catch((error) => {
        reject(error);
        ErrorMessage(error);
      });
  });
};

export { Post, Get, Update, Delete, baseUrl, imageUrl };
